export default "__VITE_ASSET__DnyLBFhg__"